module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/yamanaka_onsen_soyu-399d7f972f4e5432c77dc32af4952792.jpg";